import { useSearchParams } from 'next/navigation'
import { useRouter } from 'next/router'
import { useCallback } from 'react'

const SEARCH_PATH = '/search-results'

export const useSearch = () => {
  const searchParams = useSearchParams()
  const router = useRouter()

  const searchQuery = searchParams.get('query')

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString())

      params.set(name, value)

      return params.toString()
    },
    [searchParams],
  )

  const setSearchQuery = (value?: string | null | undefined) => {
    if (!value) {
      return router.push(SEARCH_PATH)
    }

    return router.push(SEARCH_PATH + '?' + createQueryString('query', value))
  }

  return {
    searchQuery,
    setSearchQuery,
  }
}
